<!--授权管理页面-->
<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="8" :md="8" :sm="24">
            <a-form-item label="系统名">
              <a-input
                placeholder="请输入系统名"
                v-model="queryParam.systemName"
                :max-length="50"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="8" :md="8" :sm="24">
            <a-form-item label="系统代码">
              <a-input
                placeholder="请输入系统代码"
                v-model="queryParam.systemCode"
                :max-length="50"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span
              style="float: left; overflow: hidden"
              class="table-page-search-submitButtons"
            >
              <a-button type="primary" @click="searchQuery" icon="search"
                >查询</a-button
              >
              <a-button
                type="primary"
                @click="searchReset"
                icon="reload"
                style="margin-left: 8px"
                >重置</a-button
              >
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleModalForm" type="primary" icon="plus"
        >新增</a-button
      >
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down" />
        </a-button>
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="betchDelete"
            ><a-icon type="delete" />批量删除</a-menu-item
          >
          <a-menu-item key="2"><a-icon type="delete" />批量授权</a-menu-item>
          <a-menu-item key="3" @click="betchEnable('1')"
            ><a-icon type="delete" />批量启用</a-menu-item
          >
          <a-menu-item key="4" @click="betchEnable('0')"
            ><a-icon type="delete" />批量禁用</a-menu-item
          >
        </a-menu>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
        >项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :scroll="{ x: true }"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
        }"
        class="j-table-force-nowrap"
        @change="handleTableChange"
      >
        <span slot="action" slot-scope="text, record">
          <a @click="handleImpower(record)">接口授权</a>
          <a-divider type="vertical" />
          <a @click="handleModalForm(record)">编辑</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link"> 更多 <a-icon type="down" /> </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleEnable(record)">{{
                  record.isEnable == 0 ? '启用' : '禁用'
                }}</a>
              </a-menu-item>
              <a-menu-item>
                <a @click="handleSecret(record, '1')">查看密匙</a>
              </a-menu-item>
              <a-menu-item>
                <a @click="handleSecret(record, '2')">重置密匙</a>
              </a-menu-item>
              <a-menu-item>
                <a @click="handleStatistics(record.id)">调用统计</a>
              </a-menu-item>
              <a-menu-item>
                <a @click="deleteRecord(record)">删除</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>
    <!-- 新增/编辑模态框 -->
    <authorization-modal
      ref="modalForm"
      @ok="modalFormOk"
    ></authorization-modal>
    <!-- 查看/重置密匙模态框 -->
    <lookKey-modal ref="lookModal" @ok="modalFormOk"></lookKey-modal>
    <!-- 接口授权模态框 -->
    <impower-modal ref="impowerModal" @ok="modalFormOk"></impower-modal>
    <!-- 统计模态框 -->
    <statistics-modal
      ref="statisticsModal"
      @ok="modalFormOk"
    ></statistics-modal>
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less';
import AuthorizationModal from './modules/editModal';
import LookKeyModal from './modules/lookKeyModal';
import ImpowerModal from './modules/impowerModal';
import StatisticsModal from './modules/statisticsModal';
import JDictSelectTag from '@/components/dict/JDictSelectTag.vue';
import customRender from '@/utils/customRender.js';
import { getAction, postAction, jsonAction } from '../../../api/manage';

export default {
  name: 'AuthorizationList',
  components: {
    JDictSelectTag,
    AuthorizationModal,
    LookKeyModal,
    ImpowerModal,
    StatisticsModal,
  },
  data() {
    return {
      loading: false,
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0,
      },
      queryParam: {
        systemName: '',
        systemCode: '',
      },
      dataSource: [],
      selectedRowKeys: [],
      selectionRows: [],
      // 表头
      columns: [
        {
          title: '系统名',
          align: 'center',
          dataIndex: 'systemName',
          width: 200,
        },

        {
          title: '系统代码',
          align: 'center',
          dataIndex: 'systemCode',
          width: 200,
          customRender: customRender,
        },
        {
          title: '密钥',
          align: 'center',
          dataIndex: 'secretKey',
          customRender: customRender,
          width: 200,
        },
        {
          title: '密钥更新时间',
          align: 'center',
          dataIndex: 'keyUpdateTime',
          width: 200,
          customRender: customRender,
        },
        {
          title: '密钥更新人',
          align: 'center',
          dataIndex: 'keyUpdateUser',
          customRender: customRender,
          width: 200,
        },
        {
          title: '来源IP',
          align: 'center',
          dataIndex: 'keyUpdateIp',
          width: 200,
          customRender: (text) => {
            return !text || text == '' ? '--' : text;
          },
        },
        {
          title: '授权接口数量',
          align: 'center',
          dataIndex: 'interfaceNum',
          customRender: customRender,
          width: 200,
        },
        {
          title: '是否记录日志',
          align: 'center',
          dataIndex: 'isLog',
          width: 150,
          customRender: (text) => {
            if (text === '' || text == null) {
              return '--';
            } else {
              return text == 0 ? '否' : '是';
            }
          },
        },
        {
          title: '是否启用',
          align: 'center',
          dataIndex: 'isEnable',
          width: 150,
          customRender: (text) => {
            if (text === '' || text == null) {
              return '--';
            } else {
              return text == 0 ? '否' : '是';
            }
          },
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 200,
          scopedSlots: { customRender: 'action' },
        },
      ],
      url: {
        list: process.env.VUE_APP_CMS_SYSTEM + '/sys/auth/app/page',
        update: process.env.VUE_APP_CMS_SYSTEM + '/sys/auth/app/batch/update',
        delete: process.env.VUE_APP_CMS_SYSTEM + '/sys/auth/app/batch/delete',
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // 获取数据
    getList() {
      let that = this;
      let params = {
        ...this.queryParam,
        pageNo: that.ipagination.current,
        pageSize: that.ipagination.pageSize,
      };
      that.loading = true;
      getAction(this.url.list, params).then((res) => {
        that.loading = false;
        if (res.success) {
          that.dataSource = res.result.records;
          that.ipagination.total = res.result.total;
        } else {
          that.$message.error(res.message);
        }
      });
    },
    // 获取点中时的数据
    onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectionRows = selectionRows;
    },
    handleModalForm(record) {
      this.$refs.modalForm.title = record ? '编辑' : '新增';
      let obj = record ? record : {};
      this.$refs.modalForm.edit(obj);
    },
    // 密匙弹窗
    handleSecret(record, flg) {
      this.$refs.lookModal.edit(record, flg);
    },
    //更新
    handleEnable(record) {
      let desc = record.isEnable == 0 ? '启用' : '禁用';
      let params = [
        {
          id: record.id,
          isEnable: record.isEnable == 0 ? '1' : '0',
        },
      ];
      this.handleUpdate(params, desc);
    },
    betchEnable(flg) {
      let desc = flg == 1 ? '启用' : '禁用';
      let target = this.selectionRows.findIndex((item) => item.isEnable == flg);
      if (target > -1) {
        this.$message.error('选中数据存在启用/禁用状态，请重新选择');
      } else {
        let list = [];
        this.selectionRows.forEach((item) => {
          list.push({
            id: item.id,
            isEnable: flg,
          });
        });
        this.handleUpdate(list, '批量' + desc);
      }
    },
    //删除
    deleteRecord(record) {
      let params = [
        {
          id: record.id,
          isDelete: 1,
        },
      ];
      this.handleUpdate(params, '删除');
    },
    betchDelete() {
      let list = [];
      this.selectionRows.forEach((item) => {
        list.push({
          id: item.id,
          isDelete: 1,
        });
      });
      this.handleUpdate(list, '批量删除');
    },

    handleUpdate(params, desc) {
      let that = this;
      this.$confirm({
        title: '确认' + desc,
        content: '是否' + desc + '当前数据?',
        onOk: function () {
          that.loading = true;
          jsonAction(that.url.update, params, 'post')
            .then((res) => {
              if (res.success) {
                that.onClearSelected();
                that.getList();
              } else {
                that.$message.error(res.message);
              }
            })
            .finally(() => {
              that.loading = false;
            });
        },
      });
    },
    // 接口授权
    handleImpower(record) {
      this.$refs.impowerModal.add(record);
      this.$refs.impowerModal.title = '接口授权';
    },
    // 调用统计
    handleStatistics(id) {
      this.$refs.statisticsModal.add(id);
      this.$refs.statisticsModal.title = '调用统计';
      this.$refs.statisticsModal.disableSubmit = false;
    },
    modalFormOk() {
      // 新增/修改 成功时，重载列表
      this.getList();
    },
    searchQuery() {
      this.getList();
    },
    //重置
    searchReset() {
      this.queryParam = {
        systemCode: '',
        systemName: '',
      };
      this.getList();
    },
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectionRows = [];
    },
    //分页
    handleTableChange(pagination, filters, sorter) {
      this.onClearSelected();
      this.ipagination = pagination;
      this.getList();
    },
  },
};
</script>
<style scoped>
.table-operator {
  margin-bottom: 10px;
}
</style>
